var $ = require('jquery');

function megaMenu()
{
    // mega menu
    $('.toolbar .has-children > a').on('click', function(e) {
        e.preventDefault();
        var menuID = $(this).data('menu'),
            menuItem = $('#' + menuID);

        if($('.HomePage').length) {
            $('.mega-menu-wrapper').css('margin-top',$('.toolbar').outerHeight());
        }

        // close any megamenus that are open
        $('.mega-menu-wrapper').each(function(i, element){
            // loop over all except the clicked on one.
            if(element.id !== menuID){
                var $element = $(element);
                if($element.hasClass('show')){
                    $element.slideUp();
                    $element.removeClass('show');
                }
            }
        });

        if(menuItem.hasClass('show')) {
            menuItem.slideUp();
            $(this).removeClass('open');
            menuItem.removeClass('show');
        } else {
            $('.has-children > a').removeClass('open');
            menuItem.slideDown();
            $(this).addClass('open');
            menuItem.addClass('show');
        }
    });

    $('.mega-menu .close-btn').on('click', function(e) {
        e.preventDefault();
        var menuID = $(this).data('menu'),
            menuItem = $('#' + menuID);

        menuItem.slideUp();
        $('.has-children > a').removeClass('open');
        menuItem.removeClass('show');
    });
}

module.exports = megaMenu;



// WEBPACK FOOTER //
// ./themes/base/js/megamenu.js